/**
 * sign-in-method.ts
 * How a company's users sign in (identity.company.sign_in_method).
 *
 *   - password  — email + password (the default).
 *   - microsoft — "Ingresar con Microsoft" only: users are created without a
 *                 password and the password login skips this company.
 *   - google    — same, with Google Workspace.
 */
import { z } from 'zod';

export const SIGN_IN_METHODS = ['password', 'microsoft', 'google'] as const;
export const SignInMethodSchema = z.enum(SIGN_IN_METHODS);
export type SignInMethod = z.infer<typeof SignInMethodSchema>;

export const SIGN_IN_METHOD_LABELS: Record<SignInMethod, string> = {
  password: 'Email y contraseña',
  microsoft: 'Microsoft',
  google: 'Google',
};
